import { forwardRef } from 'react';

import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';

const Transition = forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

export default styled((props) => <Dialog TransitionComponent={Transition} keepMounted {...props} />)(() => ({}));
